import React, { useState } from 'react';

import * as Yup from 'yup';

import CrudForm from '../../../../Form/CrudForm';
import Table from '../../../../Table';
import TransactionsTableModal from './TransactionsTableModal';

const fields = [
  {
    label: 'Account Holder',
    placeholder: 'Type first name',
    name: 'name',
    type: 'text',
    validation: Yup.string().required('This field is required'),
  },
  {
    label: 'Pay Loan out of the Account',
    name: 'payLoanWith',
    type: 'text',
    validation: Yup.string().required('This field is required'),
  },
  {
    label: 'Type',
    name: 'type',
    type: 'text',
  },
  {
    label: 'Personal or Business',
    name: 'personalOrBusiness',
    type: 'text',
  },
  {
    label: 'Financial Institution',
    name: 'bankName',
    type: 'text',
  },
  {
    label: 'Average Balance',
    name: 'averageBalance',
    type: 'currency',
  },
  {
    label: 'Account Number',
    name: 'accountNumber',
    type: 'text',
  },
  {
    label: 'Average Deposit',
    name: 'averageDeposit',
    type: 'currency',
  },
  {
    label: 'Routing Number',
    name: 'routingNumber',
    type: 'text',
  },
  {
    label: 'Available Cash Override',
    name: 'availableCashOverride',
    type: 'currency',
  },
  {
    label: 'Months Provided',
    name: 'monthsProvided',
    type: 'text',
  },
  {
    label: 'Available Cash',
    name: 'availableCash',
    type: 'currency',
  },
  {
    label: 'Expense Ratio',
    name: 'expenseRatio',
    type: 'text',
  },
  {
    label: 'Recognized Income',
    name: 'recognizedIncome',
    type: 'currency',
  },
];

export default function BankStatementCollection({
  bankStatementCollection,
  refetch,
  index,
}) {
  const [isTransactionsTableModalVisible, setIsTransactionsTableModalVisible] =
    useState(false);
  const [currentBankStatement, setCurrentBankStatement] = useState(null);

  const cols = [
    {
      title: 'Reg Date',
      key: 'beginningDate',
      type: 'date',
    },
    {
      title: 'Deposits',
      key: 'depositsTotal',
      type: 'currency',
      onClick: (value, row) => {
        setCurrentBankStatement(row);
        setIsTransactionsTableModalVisible(true);
      },
    },
    {
      title: 'Exclusions',
      key: 'exclusionsSum',
      type: 'currency',
      onClick: (value, row) => {
        setCurrentBankStatement(row);
        setIsTransactionsTableModalVisible(true);
      },
    },
    {
      title: 'Net Deposits',
      key: 'netDeposits',
      type: 'currency',
    },
    {
      title: 'Ending Balance',
      key: 'endingBalance',
      type: 'currency',
    },
  ];

  return (
    <div className="h-full">
      <section className="bg-white dark:bg-gray-900">
        <div className="pt-8 px-4 mx-auto max-w-2xl lg:pt-16">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              Bank Statement Collection #{index + 1}
            </h2>
          </div>
          <CrudForm fields={fields} data={bankStatementCollection} disabled />
        </div>
        <div className="mx-auto max-w-screen-xl px-4 lg:px-12 pt-4">
          <Table
            cols={cols}
            rows={bankStatementCollection?.bankStatements}
            countName="Bank Statements"
          />
        </div>
      </section>
      <TransactionsTableModal
        isVisible={isTransactionsTableModalVisible}
        hideModal={() => setIsTransactionsTableModalVisible(false)}
        transactions={currentBankStatement?.transactions}
        refetch={refetch}
      />
    </div>
  );
}
